interface ContainerNumberFilterTarget {
  setContainerNumberFilter: (value: string) => void
}

export const ISSUE_CONTAINER_NUMBER_QUERY_PARAM = 'containerNumber'

export const getContainerNumberFromIssuesQuery = (search: string): string | undefined => {
  const value = new URLSearchParams(search).get(ISSUE_CONTAINER_NUMBER_QUERY_PARAM)?.trim()

  return value || undefined
}

export const applyIssuesQueryFilters = (
  search: string,
  target: ContainerNumberFilterTarget,
): void => {
  const containerNumber = getContainerNumberFromIssuesQuery(search)

  if (!containerNumber) return

  target.setContainerNumberFilter(containerNumber)
}
